module.exports = "controllers:\n    resource: ../src/Controller/\n    type: annotation"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/pages/code/routes-2.txt
// module id = 654
// module chunks = 166022795811749